/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface ExerciseWeightDto
 */
export interface ExerciseWeightDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ExerciseWeightDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseWeightDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseWeightDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ExerciseWeightDto
     */
    deleted: string | null;

    /**
     * @type {number}
     * @memberof ExerciseWeightDto
     */
    bias: number;

    /**
     * @type {number}
     * @memberof ExerciseWeightDto
     */
    factor: number;

    /**
     * @type {string}
     * @memberof ExerciseWeightDto
     */
    type: ExerciseWeightDtoTypeEnum;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseWeightDto
     */
    exercise: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseWeightDto
     */
    client: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum ExerciseWeightDtoTypeEnum {
    HEAD = 'HEAD',
    NECK = 'NECK',
    SPINE = 'SPINE',
    LOWERLEFTARM = 'LOWER_LEFT_ARM',
    LOWERRIGHTARM = 'LOWER_RIGHT_ARM',
    UPPERLEFTARM = 'UPPER_LEFT_ARM',
    UPPERRIGHTARM = 'UPPER_RIGHT_ARM',
    LOWERLEFTLEG = 'LOWER_LEFT_LEG',
    LOWERRIGHTLEG = 'LOWER_RIGHT_LEG',
    UPPERLEFTLEG = 'UPPER_LEFT_LEG',
    UPPERRIGHTLEG = 'UPPER_RIGHT_LEG',
    LEFTFOOT = 'LEFT_FOOT',
    RIGHTFOOT = 'RIGHT_FOOT'
}

